// import { Layout, Menu, Tooltip, type MenuProps } from "antd";
// import { useEffect, useMemo, useState } from "react";
// import { useMatches, useNavigate } from "react-router";
// import Scrollbar from "@/components/scrollbar";
// import { useFlattenedRoutes, usePathname, usePermissionRoutes, useRouter, useRouteToMenuFn } from "@/router/hooks";
// import { menuFilter } from "@/router/utils";
// import { useSettingActions, useSettings } from "@/store/settingStore";
// import { NAV_WIDTH } from "../config";
// import NavLogo from "./nav-logo";
// import { ThemeLayout, ThemeMode } from "#/enum";
// import { useAuth } from "@/contexts/AuthContext";
// import { RiRobot2Fill } from "react-icons/ri";
// import { useUserActions, useUserInfo } from "@/store/userStore";
// import { MdLogout } from "react-icons/md";
// import { useLoginStateContext } from "@/pages/sys/login/providers/LoginStateProvider";
// import { BarChartOutlined, DashboardFilled, DashboardOutlined, DeploymentUnitOutlined, FileExcelFilled, FolderOutlined, GlobalOutlined, HomeFilled, LinkOutlined } from "@ant-design/icons";
// import { IconButton, SvgIcon } from "@/components/icon";
// import { LuUsers } from "react-icons/lu";
// import agentIcon from '@/assets/images/robotDark.svg';
// import agentLightIcon from '@/assets/images/robotLight.svg';
// import axios from "axios";
// import { socket } from "@/socket";

// const { Sider } = Layout;

// export default function NavVertical(props: { closeSideBarDrawer?: () => void }) {
//   const navigate = useNavigate();
//   const matches = useMatches();
//   const pathname = usePathname();
//   const settings = useSettings();
//   const { themeLayout, themeMode, darkSidebar } = settings;
//   const { setSettings } = useSettingActions();
//   const { VITE_APP_URL: URL } = import.meta.env;

//   const routeToMenuFn = useRouteToMenuFn();
//   const permissionRoutes = usePermissionRoutes(); // REACTIVE: Updates on store change
//   const flattenedRoutes = useFlattenedRoutes();

//   const collapsed = useMemo(() => themeLayout === ThemeLayout.Mini, [themeLayout]);
//   const role_id = localStorage.getItem("roleId");
//   const userId = localStorage.getItem("userId");
//   const [folderStructures, setFolderStructure] = useState();


//   const menuList = useMemo(() => {
//     const menuRoutes = menuFilter(permissionRoutes);
//     let filtered;

//     if (role_id === "4" || role_id === "5") {
//       filtered = menuRoutes.filter((r) => r.path === "dashboard");
//     } else if (role_id === "1") {
//       filtered = menuRoutes.filter((r) => ["dashboard", "management", "configuration", "datacleaning"].includes(r.path));
//     }
//     else if (role_id === "3") {
//       filtered = menuRoutes.filter((r) => ["dashboard", "configuration"].includes(r.path));
//     }
//     else if (role_id === "2") {
//       filtered = menuRoutes.filter((r) => ["dashboard", "management", "configuration"].includes(r.path));
//     }
//     else {
//       filtered = menuRoutes;
//     }

//     return routeToMenuFn(filtered);
//   }, [routeToMenuFn, permissionRoutes, role_id]);

//   const [openKeys, setOpenKeys] = useState<string[]>([]);
//   useEffect(() => {
//     if (!collapsed) {
//       const keys = matches
//         .filter((match) => match.pathname !== "/" && match.pathname !== pathname)
//         .map((match) => match.pathname);
//       setOpenKeys(keys);
//     }
//   }, [collapsed, matches, pathname]);

//   const onClick: MenuProps["onClick"] = ({ key }) => {
//     const nextLink = flattenedRoutes?.find((e) => e.key === key);

//     // Handle External Links from API (Excel/PowerBI)
//     if (nextLink?.link) {
//       window.open(nextLink.link, "_blank");
//       return;
//     }

//     navigate(key);
//     props?.closeSideBarDrawer?.();
//   };

//   const sidebarTheme = useMemo(() => {
//     if (themeMode === ThemeMode.Dark) return darkSidebar ? "light" : "dark";
//     return darkSidebar ? "dark" : "light";
//   }, [themeMode, darkSidebar]);

//   const { replace } = useRouter();
//   const { clearUserInfoAndToken } = useUserActions();
//   const { backToLogin } = useLoginStateContext();

//   const userInfo = useUserInfo();

//   const logout = () => {
//     try {
//       clearUserInfoAndToken();
//       backToLogin();
//     } catch (error) {
//       console.log(error);
//     } finally {
//       replace("/login");
//     }
//   };

//   const fetchDashboardFolderTree = async () => {
//     try {
//       const response = await axios.get(`${URL}/api/dashboards/dashboards_filehandlingss/${userId}`);
//       setFolderStructure(response.data || {});
//     } catch (error) {
//       console.error("Error fetching dashboards", error);
//     }
//   }

//   useEffect(() => {
//     fetchDashboardFolderTree();
//   }, [userId])

//   // socket.io
//   useEffect(() => {
//     if (!socket) return;

//     const refreshDashboards = () => {
//       fetchDashboardFolderTree();
//     };

//     socket.on("dashboard_updated", refreshDashboards);

//     return () => {
//       socket.off("dashboard_updated", refreshDashboards);
//     };
//   }, [userId]);

//   const DASHBOARD_PREFIX_MAP = {
//     "VADB Dashboards": "VADB",
//     "Excel Dashboards": "EXCEL",
//     "PowerBI Dashboards": "BI",
//     "Web Dashboards": "WEB",
//     "AI Dashboards": "AI",
//   };
//   const DASHBOARD_ICONS = {
//     VADB: <DashboardFilled />,
//     EXCEL: <FileExcelFilled />,
//     BI: <BarChartOutlined />,
//     WEB: <GlobalOutlined />,
//     AI: <RiRobot2Fill />,
//   };
//   const slugify = (name: string) =>
//     name
//       .trim()
//       .toLowerCase()
//       .replace(/[^a-z0-9]+/g, "-")
//       .replace(/^-+|-+$/g, "");



//   const buildAllDashboardTypes = (yearObj) => {
//     return Object.entries(yearObj)
//       .filter(([key]) => DASHBOARD_PREFIX_MAP[key])
//       .flatMap(([dashboardTypeKey, folderStructures]) => {
//         const prefix = DASHBOARD_PREFIX_MAP[dashboardTypeKey];

//         return folderStructures.map((d) => {
//           const slug = slugify(d.name);
//           return {
//             label: <Tooltip placement="topLeft" title={`[${prefix}] ${d.name}`}> [{prefix}] {d.name}</Tooltip>,
//             key: `/dashboard/${d.id}/${slug}`,
//             icon: DASHBOARD_ICONS[prefix],
//             dashboardType: prefix,
//           }
//         });
//       });
//   };

//   const buildAdminDashboardMenu = (apiResponse) => {
//     return Object.entries(apiResponse).map(([clientName, clientObj]) => ({
//       label: clientName,
//       key: `client-${clientName}`,
//       icon: <FolderOutlined />,
//       children: Object.entries(clientObj.Departments || {}).map(
//         ([deptName, deptObj]) => ({
//           label: deptName,
//           key: `dept-${clientName}-${deptName}`,
//           icon: <FolderOutlined />,
//           children: Object.entries(deptObj.Year || {}).map(
//             ([year, yearObj]) => ({
//               label: year,
//               key: `year-${clientName}-${deptName}-${year}`,
//               icon: <FolderOutlined />,
//               children: buildAllDashboardTypes(yearObj),
//             })
//           ),
//         })
//       ),
//     }));
//   };

//   const buildClientDashboardMenu = (apiResponse) => {
//     const client = Object.values(apiResponse)[0];

//     return Object.entries(client?.Departments || {}).map(
//       ([deptName, deptObj]) => ({
//         label: deptName,
//         key: `dept-${deptName}`,
//         icon: <FolderOutlined />,
//         children: Object.entries(deptObj.Year || {}).map(
//           ([year, yearObj]) => ({
//             label: year,
//             key: `year-${deptName}-${year}`,
//             icon: <FolderOutlined />,
//             children: buildAllDashboardTypes(yearObj),
//           })
//         ),
//       })
//     );
//   };


//   const dashboardMenuItems = useMemo(() => {
//     if (!folderStructures) return [];
//     if (role_id === "1") {
//       return buildAdminDashboardMenu(folderStructures);
//     }
//     return buildClientDashboardMenu(folderStructures);
//   }, [folderStructures, role_id]);

//   const adminList = useMemo(() => {
//     return [
//       {
//         label: "Home",
//         key: "/dashboard/dashboard-playgrounds",
//         icon: <HomeFilled style={{ fontSize: "16px" }} />
//       },
//       //  {
//       //   label: "New Dashboard",
//       //   key: "/dashboard/new-dashboard",
//       //   icon: <DashboardOutlined style={{fontSize: "16px"}}/>
//       // },
//       // {
//       //   label: "New PowerBI Dashboard",
//       //   key: "/dashboard/new-dashboard-powerbi",
//       //   icon: <DashboardOutlined style={{fontSize: "16px"}}/>
//       // },
//       {
//         label: "Dashboards",
//         key: "dashboards",
//         icon: <DashboardFilled />,
//         children: dashboardMenuItems,
//       },
//       ["1", "2"].includes(role_id) && {
//         label: "Management",
//         icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
//         children: [
//           {
//             label: "Users Management",
//             key: '/management/user',
//             icon: <LuUsers />
//           },
//           {
//             label: role_id === "2" ? "Department Management" : "Client Management",
//             key: '/management/role',
//             icon: <DeploymentUnitOutlined />
//           },
//         ]
//       },
//       ["1", "2", "3"].includes(role_id) && {
//         label: "Configurations",
//         icon: <SvgIcon icon="ic-menu" className="ant-menu-item-icon" size="24" />,
//         children: [
//           {
//             label: "Dashboard Configuration",
//             key: '/configuration/dashboard-management',
//             icon: <DashboardFilled />
//           },
//           {
//             label: "Widget Configuration",
//             key: '/configuration/widjet-config',
//             icon: <BarChartOutlined />
//           },
//           {
//             label: "Datasource Configuration",
//             key: '/configuration/datasource-config',
//             icon: <FileExcelFilled />
//           },
//           {
//             label: "External link Configuration",
//             key: '/configuration/external-link-config',
//             icon: <LinkOutlined />
//           },
//         ]
//       },
//       ["1", "2"].includes(role_id) && {
//         label: "AI Agents",
//         icon: <img className="w-5 h-5 object-contain" src={themeMode == ThemeMode.Dark ? agentIcon : agentLightIcon} />,
//         children: [
//           // {
//           //   label: "Data cleaning Agent",
//           //   key: '/agents/upload-csv',
//           //   icon: <RiRobot2Fill />
//           // },
//           // {
//           //   label: "Data analysis Agent",
//           //   key: '/agents/new-data-analysis-agent',
//           //   icon: <RiRobot2Fill />
//           // },
//           {
//             label: "Merge CSV Files",
//             key: '/agents/merge-files',
//             icon: <RiRobot2Fill />
//           },
//           // {
//           //   label: "PowerBI Agent",
//           //   key: '/agents/new-data-analysis-agent-powerbi',
//           //   icon: <RiRobot2Fill />
//           // },
//           {
//             label: "Smart Dashboard Agent",
//             key: '/dashboard/smart-dashboard-agent',
//             icon: <RiRobot2Fill />
//           },
//         ]
//       },
//     ]
//   }, [role_id, dashboardMenuItems, themeMode])

//   const menuListCustom = useMemo(() => {
//     return [
//       {
//         label: "Home",
//         key: "/dashboard/dashboard-playgrounds",
//         icon: <HomeFilled style={{ fontSize: "16px" }} />
//       },
//       // {
//       //   label: "New Dashboard",
//       //   key: "/dashboard/new-dashboard",
//       //   icon: <DashboardOutlined style={{ fontSize: "16px" }} />
//       // },
//       // {
//       //   label: "New PowerBI Dashboard",
//       //   key: "/dashboard/new-dashboard-powerbi",
//       //   icon: <DashboardOutlined style={{ fontSize: "16px" }} />
//       // },
//       {
//         label: "Dashboards",
//         key: "dashboards",
//         icon: <DashboardFilled />,
//         children: dashboardMenuItems,
//       },
//       ["1", "2"].includes(role_id) && {
//         label: "Management",
//         icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
//         children: [
//           {
//             label: "Users Management",
//             key: '/management/user',
//             icon: <LuUsers />
//           },
//           {
//             label: role_id === "2" ? "Department Management" : "Client Management",
//             key: '/management/role',
//             icon: <DeploymentUnitOutlined />
//           },
//         ]
//       },
//       ["1", "2", "3"].includes(role_id) && {
//         label: "Configurations",
//         icon: <SvgIcon icon="ic-menu" className="ant-menu-item-icon" size="24" />,
//         children: [
//           {
//             label: "Dashboard Configuration",
//             key: '/configuration/dashboard-management',
//             icon: <DashboardFilled />
//           },
//           {
//             label: "Widget Configuration",
//             key: '/configuration/widjet-config',
//             icon: <BarChartOutlined />
//           },
//           {
//             label: "Datasource Configuration",
//             key: '/configuration/datasource-config',
//             icon: <FileExcelFilled />
//           },
//           {
//             label: "External link Configuration",
//             key: '/configuration/external-link-config',
//             icon: <LinkOutlined />
//           },
//         ]
//       },
//       ["1", "2"].includes(role_id) && {
//         label: "AI Agents",
//         icon: <img className="w-5 h-5 object-contain" src={themeMode == ThemeMode.Dark ? agentIcon : agentLightIcon} />,
//         children: [
//           // {
//           //   label: "Data cleaning Agent",
//           //   key: '/agents/upload-csv',
//           //   icon: <RiRobot2Fill />
//           // },
//           // {
//           //   label: "Data analysis Agent",
//           //   key: '/agents/new-data-analysis-agent',
//           //   icon: <RiRobot2Fill />
//           // },
//           {
//             label: "Merge CSV Files",
//             key: '/agents/merge-files',
//             icon: <RiRobot2Fill />
//           },
//           // {
//           //   label: "PowerBI Agent",
//           //   key: '/agents/new-data-analysis-agent-powerbi',
//           //   icon: <RiRobot2Fill />
//           // },
//           {
//             label: "Smart Dashboard Agent",
//             key: '/dashboard/smart-dashboard-agent',
//             icon: <RiRobot2Fill />
//           },
//         ]
//       },
//     ]
//   }, [role_id, dashboardMenuItems, themeMode])

//   const onCHange = ({ key }) => {
//     navigate(key)
//   }

//   return (
//     <Sider
//       trigger={null}
//       collapsible
//       collapsed={collapsed}
//       width={NAV_WIDTH}
//       theme={sidebarTheme}
//       style={sidebarTheme === "dark" ? {} : { backgroundColor: "#f2f0f1" }}
//       className="!fixed left-0 top-0 h-screen border-r border-dashed border-border"
//     >
//       <div className="flex h-full flex-col">
//         <NavLogo collapsed={collapsed} onToggle={() => setSettings({ ...settings, themeLayout: collapsed ? ThemeLayout.Vertical : ThemeLayout.Mini })} />
//         <Scrollbar>
//           <Menu
//             mode="inline"
//             items={role_id === "1" ? adminList : menuListCustom}
//             theme={sidebarTheme}
//             // selectedKeys={[pathname]}
//             // openKeys={openKeys}
//             // onOpenChange={setOpenKeys}
//             defaultOpenKeys={['/dashboard/dashboard-playgrounds']}
//             selectedKeys={[pathname]}
//             style={{ background: 'transparent' }}
//             className="!border-none custom-menu"
//             onClick={onCHange}
//           />
//         </Scrollbar>
//         <div className="mt-auto  w-full h-max p-4 mb-4 " >
//           {
//             collapsed ? (
//               <div className="flex gap-4 items-center flex-col">
//                 <div className="bg-[#784af8] size-4  p-4 flex items-center justify-center rounded-full">
//                   <span>{userInfo?.name[0]}</span>
//                 </div>

//                 <div className=" text-error cursor-pointer" onClick={logout}>
//                   <IconButton>
//                     <MdLogout size={"25px"} />
//                   </IconButton>
//                 </div>
//               </div>
//             ) : (
//               <div className="flex gap-2 items-center">
//                 <div className="bg-[#784af8] size-4  p-5 flex items-center justify-center rounded-full">
//                   <span className="text-[#fff]">{userInfo?.name[0]}</span>
//                 </div>
//                 <div className="flex flex-col">
//                   <span className="font-bold truncate text-md w-[150px]">{userInfo?.name}</span>
//                   <span className="text-sm w-[140px] truncate opacity-50 font-medium">{userInfo?.email}</span>
//                 </div>
//                 <div className="ml-auto text-error cursor-pointer" onClick={logout}>
//                   <IconButton>
//                     <MdLogout size={"25px"} />
//                   </IconButton>

//                 </div>
//               </div>
//             )
//           }
//         </div>
//       </div>
//     </Sider>
//   );
// }

import { Button, Layout, Menu, Progress, Tooltip, type MenuProps } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useMatches, useNavigate } from "react-router";
import Scrollbar from "@/components/scrollbar";
import { useFlattenedRoutes, usePathname, usePermissionRoutes, useRouter, useRouteToMenuFn } from "@/router/hooks";
import { menuFilter } from "@/router/utils";
import { useSettingActions, useSettings } from "@/store/settingStore";
import { NAV_WIDTH } from "../config";
import NavLogo from "./nav-logo";
import { ThemeLayout, ThemeMode } from "#/enum";
import { useAuth } from "@/contexts/AuthContext";
import { RiRobot2Fill } from "react-icons/ri";
import useUserStore, { useCreditsRemaining, useDaysRemaining, useTrialEndTime, useUserActions, useUserInfo, useInsufficientModalOpen, useTier, useTierId } from "@/store/userStore";
import { MdLogout } from "react-icons/md";
import { useLoginStateContext } from "@/pages/sys/login/providers/LoginStateProvider";
import { BarChartOutlined, CheckCircleFilled, CheckOutlined, DashboardFilled, DashboardOutlined, DeploymentUnitOutlined, FileExcelFilled, FolderOutlined, GlobalOutlined, HomeFilled, LinkOutlined, QuestionCircleOutlined, StarOutlined, LockOutlined, AppstoreOutlined } from "@ant-design/icons";
import { IconButton, SvgIcon } from "@/components/icon";
import { LuLayoutDashboard, LuUsers } from "react-icons/lu";
import agentIcon from '@/assets/images/robotDark.svg';
import agentLightIcon from '@/assets/images/robotLight.svg';
import valiantlytixLogo from '@/assets/images/logo.png';
import axios from "axios";
import { socket } from "@/socket";
import RemainderDaysModal from "@/components/RemainderDaysModal";
import ZeroDayRemainingModal from "@/components/ZeroDayRemainingModal";
import ExtensionDetailsModal from "@/pages/CleanDashboardFlowAgentVersion3/utils/ExtensionDetailsModal";
import RemainingCreditsModal from "@/components/RemainingCreditsModal";
import ZeroCreditsModal from "@/components/ZeroCreditsModal";
import InsufficientCreditModal from "@/components/InsuffiecientCreditModal";
import PaymentDueModal from "@/components/PaymentDueModal";
// Restored store import
import { useInstantAIDashboardActions } from "@/store/instantAIDashboardStore";
import { isFeatureRestricted } from "@/utils/featureRestrictions";
import { TbDeviceDesktop } from "react-icons/tb";
import { FiCpu, FiLayers } from "react-icons/fi";
import { IoIosAnalytics } from "react-icons/io";
import { IoAnalytics } from "react-icons/io5";

const { Sider } = Layout;

export default function NavVertical(props: { closeSideBarDrawer?: () => void, isBlocked?: boolean }) {
  const navigate = useNavigate();
  const matches = useMatches();
  const pathname = usePathname();
  const settings = useSettings();
  const dayRemaining = useDaysRemaining();
  const creditsRemaining = useCreditsRemaining();
  const { themeLayout, themeMode, darkSidebar } = settings;
  const { setSettings } = useSettingActions();
  const { VITE_APP_URL: URL } = import.meta.env;
  const { setDaysRemaining, setTrialEndTime, setInsufficientModalOpen, setHasInsufficientCredits } = useUserActions();
  const insufficientModalOpen = useInsufficientModalOpen();
  const { resetAll } = useInstantAIDashboardActions();
  const tier = useTier();
  const tierId = useTierId();
  const isTrial = !tier || tierId === 1 || !['lite', 'standard', 'premium'].includes(tier.toLowerCase());
  const trialEndTime = useTrialEndTime();
  const featureAccess = useUserStore((state) => state.featureAccess);

  const routeToMenuFn = useRouteToMenuFn();
  const permissionRoutes = usePermissionRoutes(); // REACTIVE: Updates on store change
  const collapsed = useMemo(() => themeLayout === ThemeLayout.Mini, [themeLayout]);
  const userInfo = useUserInfo() as any;
  const role_id = String(localStorage.getItem("roleId") || userInfo?.role_id || "");
  const isSuperAdmin = role_id === "1" || userInfo?.role_id === 1 || String(userInfo?.role_id) === "1";
  const userId = localStorage.getItem("userId");
  const [folderStructures, setFolderStructure] = useState();
  const [daysRemainings , setDaysRemainings] = useState();
  const [daysPercent , setDaysPercent] = useState<number>();
  const [remainModalOpen ,   setRemainModal] = useState(false);
  const [zeroRemainModalOpen ,   setZeroRemainModal] = useState(false);
  const [extendTrialSubmitted , setExtendTrialSubmitted] = useState(false);
  const { VITE_AGENT_URL } = import.meta.env;
  const [remainingModalOpen, setRemainingModalOpen] = useState(false);
	const [zeroModalOpen, setZeroModalOpen] = useState(false);
  const [paymentDueModalOpen, setPaymentDueModalOpen] = useState(false);
  const [paymentDueData, setPaymentDueData] = useState<any>(null);
  


  const menuList = useMemo(() => {
    const menuRoutes = menuFilter(permissionRoutes);
    let filtered;

    if (role_id === "4" || role_id === "5") {
      filtered = menuRoutes.filter((r) => r.path === "dashboard");
    } else if (role_id === "1") {
      filtered = menuRoutes.filter((r) => ["dashboard", "management", "configuration", "datacleaning"].includes(r.path));
    }
    else if (role_id === "3") {
      filtered = menuRoutes.filter((r) => ["dashboard", "configuration"].includes(r.path));
    }
    else if (role_id === "2") {
      filtered = menuRoutes.filter((r) => ["dashboard", "management", "configuration"].includes(r.path));
    }
    else {
      filtered = menuRoutes;
    }

    return routeToMenuFn(filtered);
  }, [routeToMenuFn, permissionRoutes, role_id]);

  const [openKeys, setOpenKeys] = useState<string[]>([]);
  useEffect(() => {
    if (!collapsed) {
      const keys = matches
        .filter((match) => match.pathname !== "/" && match.pathname !== pathname)
        .map((match) => match.pathname);
      setOpenKeys(keys);
    }
  }, [collapsed, matches, pathname]);

  const onClick: MenuProps["onClick"] = ({ key }) => {
    const nextLink = flattenedRoutes?.find((e) => e.key === key);

    // Handle External Links from API (Excel/PowerBI)
    if (nextLink?.link) {
      window.open(nextLink.link, "_blank");
      return;
    }

    navigate(key);
    props?.closeSideBarDrawer?.();
  };

  const sidebarTheme = useMemo(() => {
    if (themeMode === ThemeMode.Dark) return darkSidebar ? "light" : "dark";
    return darkSidebar ? "dark" : "light";
  }, [themeMode, darkSidebar]);

  const { replace } = useRouter();
  const { clearUserInfoAndToken } = useUserActions();
  const { backToLogin } = useLoginStateContext();

  const logout = () => {
    try {
      clearUserInfoAndToken();
      backToLogin();
    } catch (error) {
      console.log(error);
    } finally {
      if (window.location.pathname && window.location.pathname !== '/' && window.location.pathname !== '') {
        window.location.href = `${window.location.origin}/#/login`;
      } else {
        replace("/login");
      }
    }
  };

  const fetchDashboardFolderTree = async () => {
    try {
      const response = await axios.get(`${URL}/api/dashboards/dashboards_filehandlingss/${userId}`);
      setFolderStructure(response.data || {});
    } catch (error) {
      console.error("Error fetching dashboards", error);
    }
  }

  const fetchCreditsUsageDetails = async()=>{
    if (!userId) return;
    try {
      const creditsRes = await fetch(`${VITE_AGENT_URL}/api/v1/user/credits-status?_t=${Date.now()}`, {
					method: 'GET',
					headers: { 
						'accept': 'application/json',
						'x-user-id': String(userId),
						'Cache-Control': 'no-cache, no-store, must-revalidate',
						'Pragma': 'no-cache'
					},
					cache: 'no-store'
				});
				if (creditsRes.ok) {
					const creditsData = await creditsRes.json();
					if(creditsData.credits_remaining <= 1 && creditsData.credits_remaining > 0) setRemainingModalOpen(true);
					if(creditsData.credits_remaining <= 0) setZeroModalOpen(true);
        }
    } catch (error) {
      console.log(error)
    }
  }

  const fetchDaysReainingDetails = async()=>{
    if (!userId) return;
    try {
      const daysApiResponse = await axios.get(`${URL}/api/users/tester-pending-request/${userId}?_t=${Date.now()}`, {
        headers: { 'Cache-Control': 'no-cache' }
      });
      const apiData = daysApiResponse.data?.data;
      
      // Only process tester data if it actually contains remaining_days
      if (apiData && apiData.remaining_days !== undefined) {
          const days = apiData.remaining_days ?? 0;
          const hours = apiData.remaining_hours ?? 0;
          const minutes = apiData.remaining_minutes ?? 0;
    
          setDaysRemainings(days)
          setDaysRemaining(days)
    
          // Compute precise end timestamp from days + hours + minutes
          const endTime = Date.now() + ((days * 24 * 60) + (hours * 60) + minutes) * 60 * 1000;
          setTrialEndTime(apiData.expired ? 0 : endTime);
    
          let daypercentUsed = 100 - ((days / 15) * 100)
          setDaysPercent(daypercentUsed);
    
          if (isTrial && [3, 2, 1].includes(days)){
            setRemainModal(true);
          }
      } else {
          // If no tester API data exists (e.g. brand new user), use the store's daysRemaining (which comes from credits-status)
          const storeDays = useUserStore.getState().daysRemaining || 0;
          if (storeDays > 0) {
              const endTime = Date.now() + (storeDays * 24 * 60 * 60 * 1000);
              setTrialEndTime(endTime);
          }
      }
      // Zero-day modal is now triggered by the countdown timer useEffect below,
      // so it shows only after the header countdown reaches 00:00:00:00
    } catch (error) {
      console.log(error)
    }
  }

  const fetchPaymentDueNotification = async () => {
    if (!userId || isTrial) return;
    try {
        const response = await axios.get(`${URL}/api/users/payment-due-notification?_t=${Date.now()}`, {
            headers: {
                "User-Id": userId,
                'Cache-Control': 'no-cache'
            }
        });
        const data = response.data;
        if (data && data.show_notification && !isTrial) {
            setPaymentDueData(data);
            setPaymentDueModalOpen(true);
        }
    } catch (error) {
        console.error("Error fetching payment due notification", error);
    }
  }
  const fetchExtensionSubmissionStatus = async()=>{
        if (!userId) return;
        try{
            const response = await axios.get(`${URL}/api/users/tester-extension-status/${Number(userId)}?_t=${Date.now()}`, {
                headers: { 'Cache-Control': 'no-cache' }
            });   
            if(response?.data?.data?.extension_request_used){
                setExtendTrialSubmitted(true);
            }
        }catch(error){
            console.error(error);
        }
    }

  useEffect(()=>{fetchExtensionSubmissionStatus()},[])
  useEffect(()=>{
    fetchCreditsUsageDetails();
  },[userId])

  useEffect(() => {
    const role_id = localStorage.getItem("roleId") || localStorage.getItem("role_id");
    if (creditsRemaining !== null && creditsRemaining !== undefined && role_id !== "1") {
      if (creditsRemaining < 1) {
        setHasInsufficientCredits(true);
        setInsufficientModalOpen(true);
      }
    }
  }, [creditsRemaining]);

  useEffect(() => {
    if (!userId) return;

    // Initial fetch
    if (isTrial) {
      fetchDaysReainingDetails();
    } else {
      fetchPaymentDueNotification();
    }

    // Fetch every 1 hour (3600000 ms)
    const interval = setInterval(() => {
      if (isTrial) {
        fetchDaysReainingDetails();
      } else {
        fetchPaymentDueNotification();
      }
    }, 60 * 60 * 1000);

    // Cleanup
    return () => clearInterval(interval);
  }, [userId, isTrial]);

  // Show ZeroDayRemainingModal when countdown reaches zero (only for trial users)
  useEffect(() => {
    if (!isTrial) return;
    if (trialEndTime === null) return; // Not yet fetched
    if (extendTrialSubmitted) return; // Already submitted extension request, do not show zero modal

    if (trialEndTime <= 0) {
      // Already expired (API said expired)
      setZeroRemainModal(true);
      return;
    }

    const msLeft = trialEndTime - Date.now();
    if (msLeft <= 0) {
      // Expired since last fetch
      setZeroRemainModal(true);
      return;
    }

    // Schedule modal to show exactly when countdown hits zero
    const timeout = setTimeout(() => {
      setZeroRemainModal(true);
    }, msLeft);

    return () => clearTimeout(timeout);
  }, [trialEndTime, extendTrialSubmitted, isTrial]);

  useEffect(() => {
    fetchDashboardFolderTree();
  }, [userId])

  // socket.io — server-broadcast events
  useEffect(() => {
    if (!socket) return;

    const refreshDashboards = () => {
      fetchDashboardFolderTree();
    };

    socket.on("dashboard_updated", refreshDashboards);
    socket.on("dashboard_created", refreshDashboards);
    socket.on("dashboard_structure_built", refreshDashboards);

    window.addEventListener("dashboardCreated", refreshDashboards);

    return () => {
      socket.off("dashboard_updated", refreshDashboards);
      socket.off("dashboard_created", refreshDashboards);
      socket.off("dashboard_structure_built", refreshDashboards);
      window.removeEventListener("dashboardCreated", refreshDashboards);
    };
  }, [socket]);

  // local browser event — fires when a dashboard is deleted from this tab
  useEffect(() => {
    const handleDeleted = () => fetchDashboardFolderTree();
    window.addEventListener("dashboard:deleted", handleDeleted);
    return () => window.removeEventListener("dashboard:deleted", handleDeleted);
  }, []);

  const DASHBOARD_PREFIX_MAP: Record<string, string> = {
    "VADB Dashboards": "VADB",
    "Excel Dashboards": "EXCEL",
    "PowerBI Dashboards": "BI",
    "Web Dashboards": "WEB",
    "AI Dashboards": "AI",
    "AI agent-Master Dashboards": "AI",
    "AI agent-Others Dashboards": "AI",
    "AI agent-Child Dashboards": "AI",
  };
  const getPrefixForKey = (key: string): string => {
    if (!key) return "AI";
    if (DASHBOARD_PREFIX_MAP[key]) return DASHBOARD_PREFIX_MAP[key];
    const lower = key.toLowerCase();
    if (lower.includes("vadb")) return "VADB";
    if (lower.includes("excel")) return "EXCEL";
    if (lower.includes("powerbi") || lower.includes("power-bi") || lower.includes("power bi") || lower.includes("bi")) return "BI";
    if (lower.includes("web")) return "WEB";
    return "AI";
  };
  const DASHBOARD_ICONS = {
    VADB: <DashboardFilled />,
    EXCEL: <FileExcelFilled />,
    BI: <BarChartOutlined />,
    WEB: <GlobalOutlined />,
    AI: <RiRobot2Fill />,
  };
  const slugify = (name: string) =>
    name
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const buildAllDashboardTypes = (yearObj: any) => {
    if (!yearObj || typeof yearObj !== "object") return [];
    return Object.entries(yearObj)
      .filter(([_, val]) => Array.isArray(val) && (val as any[]).length > 0)
      .flatMap(([dashboardTypeKey, folderStructures]: [string, any]) => {
        const prefix = getPrefixForKey(dashboardTypeKey);

        return (folderStructures || []).map((d: any) => {
          const slug = slugify(d.name || "dashboard");
          return {
            label: <Tooltip placement="topLeft" title={`[${prefix}] ${d.name}`}>{d.name}</Tooltip>,
            key: `/dashboard/${d.id}/${slug}`,
            icon:  <div className={`w-max px-1 h-[22px] ${sidebarTheme === "dark" ? 'bg-[#C4123020] text-[#FCA5A5] border-[#C4123050]' : 'bg-[#FEF2F2] text-[#C41230] border-[#FEE2E2]'} text-[9px] font-semibold uppercase flex items-center justify-center rounded-md border-[1px]`}>{prefix}</div>,
            dashboardType: prefix,
          };
        });
      });
  };

  const buildAdminDashboardMenu = (apiResponse: any) => {
    const treeObj = apiResponse?.tree || apiResponse;
    if (!treeObj || typeof treeObj !== "object") return [];
    return Object.entries(treeObj).map(([clientName, clientObj]: [string, any]) => ({
      label: clientName,
      key: `client-${clientName}`,
      icon: <FolderOutlined />,
      children: Object.entries(clientObj?.Departments || {}).map(
        ([deptName, deptObj]: [string, any]) => ({
          label: deptName,
          key: `dept-${clientName}-${deptName}`,
          icon: <FolderOutlined />,
          children: Object.entries(deptObj?.Year || {}).map(
            ([year, yearObj]: [string, any]) => ({
              label: year,
              key: `year-${clientName}-${deptName}-${year}`,
              icon: <FolderOutlined />,
              children: buildAllDashboardTypes(yearObj),
            })
          ),
        })
      ),
    }));
  };

  const buildClientDashboardMenu = (apiResponse: any) => {
    const treeObj = apiResponse?.tree || apiResponse;
    if (!treeObj || typeof treeObj !== "object") return [];
    const clients = Object.values(treeObj) as any[];

    return clients.flatMap((client: any) =>
      Object.entries(client?.Departments || {}).map(
        ([deptName, deptObj]: [string, any]) => ({
          label: deptName,
          key: `dept-${deptName}`,
          icon: <FolderOutlined />,
          children: Object.entries(deptObj?.Year || {}).map(
            ([year, yearObj]: [string, any]) => ({
              label: year,
              key: `year-${deptName}-${year}`,
              icon: <FolderOutlined />,
              children: buildAllDashboardTypes(yearObj),
            })
          ),
        })
      )
    );
  };

  const buildFlatDashboardMenu = (apiResponse: any) => {
    const treeObj = apiResponse?.tree || apiResponse;
    if (!treeObj || typeof treeObj !== "object") return [];
    const clients = Object.values(treeObj) as any[];
    if (!clients || clients.length === 0) return [];

    const dashboards: any[] = [];
    clients.forEach((client: any) => {
      if (!client || typeof client !== "object") return;
      Object.values(client?.Departments || {}).forEach((deptObj: any) => {
        if (!deptObj || typeof deptObj !== "object") return;
        Object.values(deptObj?.Year || {}).forEach((yearObj: any) => {
          if (!yearObj || typeof yearObj !== "object") return;
          Object.entries(yearObj).forEach(([dashboardTypeKey, folderStr]: [string, any]) => {
            if (Array.isArray(folderStr)) {
              const prefix = getPrefixForKey(dashboardTypeKey);
              folderStr.forEach((d: any) => {
                if (d && typeof d === "object" && d.id != null && d.name) {
                  const slug = slugify(d.name);
                  dashboards.push({
                    label: d.name,
                    key: `/dashboard/${d.id}/${slug}`,
                    icon: <div className={`w-[26px] h-[22px] ${sidebarTheme === "dark" ? 'bg-[#C4123020] text-[#FCA5A5] border-[#C4123050]' : 'bg-[#FEF2F2] text-[#C41230] border-[#FEE2E2]'} text-[9px] font-semibold uppercase flex items-center justify-center rounded-md border-[1px]`}>{prefix}</div>,
                    dashboardType: prefix,
                  });
                }
              });
            }
          });
        });
      });
    });
    return dashboards;
  };

  const dashboardMenuItems = useMemo(() => {
    if (!folderStructures) return [];
    const treeData = (folderStructures as any)?.tree || folderStructures;
    // All roles: show flat dashboard list directly — no nested Client/Dept/Year tree
    return buildFlatDashboardMenu(treeData);
  }, [folderStructures, role_id]);
  const adminList = useMemo(() => {
    return [
      // {
      //   label: "Home",
      //   key: "/dashboard/dashboard-playgrounds",
      //   icon: <HomeFilled style={{ fontSize: "16px" }} />
      // },
      {
        label: "Home",
        key: "/dashboard/home",
        icon: <HomeFilled style={{ fontSize: "16px" }} />
      },
      //  {
      //   label: "New Dashboard",
      //   key: "/dashboard/new-dashboard",
      //   icon: <DashboardOutlined style={{fontSize: "16px"}}/>
      // },
      // {
      //   label: "New PowerBI Dashboard",
      //   key: "/dashboard/new-dashboard-powerbi",
      //   icon: <DashboardOutlined style={{fontSize: "16px"}}/>
      // },
      {
        label: "Dashboards",
        key: "dashboards",
        icon: <DashboardFilled />,
        children: dashboardMenuItems,
      },
      ["1"].includes(role_id) && {
        label: "Management",
        icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
        children: [
          {
            label: "Users Management",
            key: '/management/user',
            icon: <LuUsers />
          },
          {
            label: role_id === "2" ? "Department Management" : "Client Management",
            key: '/management/role',
            icon: <DeploymentUnitOutlined />
          },
          {
            label: "Marketing Data Management",
            key: '/management/marketing-data',
            icon: <IoAnalytics />
          },
          {
            label: "Feature Management",
            key: '/management/feature',
            icon: <AppstoreOutlined />
          },
        ]
      },
      ["1"].includes(role_id) && {
        label: "Enterprise Management",
        icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
        children: [
          // {
          //   label: "Credit & Seat Management",
          //   key: '/management/credit-seat',
          //   icon: <DeploymentUnitOutlined />
          // },
          {
            label: "Client Onboarding",
            key: '/management/client-onboarding',
            icon: <DeploymentUnitOutlined />
          },
        ]
      },
      ["1"].includes(role_id) && {
        label: "Configurations",
        icon: <SvgIcon icon="ic-menu" className="ant-menu-item-icon" size="24" />,
        children: [
          {
            label: "Dashboard Configuration",
            key: '/configuration/dashboard-management',
            icon: <DashboardFilled />
          },
          {
            label: "Widget Configuration",
            key: '/configuration/widjet-config',
            icon: <BarChartOutlined />
          },
          {
            label: "Datasource Configuration",
            key: '/configuration/datasource-config',
            icon: <FileExcelFilled />
          },
          {
            label: "External link Configuration",
            key: '/configuration/external-link-config',
            icon: <LinkOutlined />
          },
        ]
      },
      ["1", "2"].includes(role_id) && {
        label: "AI Agents",
        icon: <img className="w-5 h-5 object-contain" src={themeMode == ThemeMode.Dark ? agentIcon : agentLightIcon} />,
        children: [
          // {
          //   label: "Data cleaning Agent",
          //   key: '/agents/upload-csv',
          //   icon: <RiRobot2Fill />
          // },
          // {
          //   label: "Data analysis Agent",
          //   key: '/agents/new-data-analysis-agent',
          //   icon: <RiRobot2Fill />
          // },
          // {
            //   label: "PowerBI Agent",
            //   key: '/agents/new-data-analysis-agent-powerbi',
            //   icon: <RiRobot2Fill />
            // },
            // {
              //   label: "Smart Dashboard Agent",
              //   key: '/dashboard/smart-dashboard-agent',
              //   icon: <RiRobot2Fill />
              // },
              {
                label: "Smart Dashboard",
                key: '/agents/smart-dashboard-agent',
                icon: <LuLayoutDashboard />
              },
              {
                label: (
                  <>
                    Data Cleaning
                    {isFeatureRestricted(tier, 'data_cleaning') && <LockOutlined className="text-red-500 ml-2" />}
                  </>
                ),
                key: '/agents/data-cleaning',
                icon: <FiCpu />
              },
              {
                label: (
                  <>
                    Merge Datasets
                    {isFeatureRestricted(tier, 'data_merging') && <LockOutlined className="text-red-500 ml-2" />}
                  </>
                ),
                key: '/agents/merge-files',
                icon: <FiLayers />
              },
        ]
      },
    ]
  }, [role_id, dashboardMenuItems, themeMode])

  const menuListCustom = useMemo(() => {
    if (role_id === "6") {
      return [
        {
          label: "Marketing Data",
          key: "/management/marketing-data",
          icon: <BarChartOutlined />
        },
        {
          label: "Enterprise Management",
          icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
          children: [
            {
              label: "Client Onboarding",
              key: '/management/client-onboarding',
              icon: <DeploymentUnitOutlined />
            },
          ]
        }
      ];
    }
    return [
      // {
      //   label: "Home",
      //   key: "/dashboard/dashboard-playgrounds",
      //   icon: <HomeFilled style={{ fontSize: "16px" }} />
      // },
       {
        label: "Home",
        key: "/dashboard/home",
        icon: <HomeFilled style={{ fontSize: "16px" }} />
      },
      // {
      //   label: "New Dashboard",
      //   key: "/dashboard/new-dashboard",
      //   icon: <DashboardOutlined style={{ fontSize: "16px" }} />
      // },
      // {
      //   label: "New PowerBI Dashboard",
      //   key: "/dashboard/new-dashboard-powerbi",
      //   icon: <DashboardOutlined style={{ fontSize: "16px" }} />
      // },
     {
        label: "Dashboards",
        key: "dashboards",
        icon: <AppstoreOutlined />,
        children: dashboardMenuItems,
      },
      role_id === "2" && {
        label: "Management",
        icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
        children: [
          {
            label: "User Management",
            key: "/management/user",
            icon: <LuUsers />
          },
           {
            label: role_id === "2" ? "Department Management" : "Client Management",
            key: '/management/role',
            icon: <DeploymentUnitOutlined />
          },
          // {
          //   label: "Credit Management",
          //   key: "/management/credits",
          //   icon: <StarOutlined />
          // }
        ]
      },
      ["1"].includes(role_id) && {
        label: "Management",
        icon: <SvgIcon icon="ic-management" className="ant-menu-item-icon" size="20" />,
        children: [
          {
            label: "Users Management",
            key: '/management/user',
            icon: <LuUsers />
          },
          {
            label: role_id === "2" ? "Department Management" : "Client Management",
            key: '/management/role',
            icon: <DeploymentUnitOutlined />
          },
          {
            label: "Marketing Data Management",
            key: '/management/marketing-data',
            icon: <IoAnalytics />
          },
          {
            label: "Feature Management",
            key: '/management/feature',
            icon: <AppstoreOutlined />
          },
        ]
      },
      ["1","2","3"].includes(role_id) && {
        label: "Configurations",
        icon: <SvgIcon icon="ic-menu" className="ant-menu-item-icon" size="24" />,
        children: [
          {
            label: "Dashboard Configuration",
            key: '/configuration/dashboard-management',
            icon: <DashboardFilled />
          },
          {
            label: "Widget Configuration",
            key: '/configuration/widjet-config',
            icon: <BarChartOutlined />
          },
          {
            label: "Datasource Configuration",
            key: '/configuration/datasource-config',
            icon: <FileExcelFilled />
          },
          {
            label: "External link Configuration",
            key: '/configuration/external-link-config',
            icon: <LinkOutlined />
          },
        ]
      },
      ["1", "2", "3","5","0"].includes(role_id) && {
        label: "AI Agents",
        icon: <TbDeviceDesktop/>,
        // icon: <img className="w-5 h-5 object-contain" src={themeMode == ThemeMode.Dark ? agentIcon : agentLightIcon} />,
        children: [
          // {
          //   label: "Data cleaning Agent",
          //   key: '/agents/upload-csv',
          //   icon: <RiRobot2Fill />
          // },
          // {
          //   label: "Data analysis Agent",
          //   key: '/agents/new-data-analysis-agent',
          //   icon: <RiRobot2Fill />
          // },
          // {
            //   label: "PowerBI Agent",
            //   key: '/agents/new-data-analysis-agent-powerbi',
            //   icon: <RiRobot2Fill />
            // },
            // {
              //   label: "Smart Dashboard Agent",
              //   key: '/dashboard/smart-dashboard-agent',
              //   icon: <RiRobot2Fill />
              // },
              {
            label: "Smart Dashboard",
            key: '/agents/smart-dashboard-agent',
            icon: <LuLayoutDashboard />
          },
              
              {
                label: (
                  <>
                    Merge Datasets
                    {isFeatureRestricted(tier, 'data_merging') && <LockOutlined className="text-red-500 ml-2" />}
                  </>
                ),
                key: '/agents/merge-files',
                icon: <FiLayers />,
                // disabled: isTrial
              },
              {
                label: (
                  <>
                    Data Cleaning
                    {isFeatureRestricted(tier, 'data_cleaning') && <LockOutlined className="text-red-500 ml-2" />}
                  </>
                ),
                key: '/agents/data-cleaning',
                icon: <FiCpu />,
                // disabled: isTrial
              },
        ]
      },
    ]
  }, [role_id, dashboardMenuItems, themeMode])

  const onCHange = ({ key }) => {
    navigate(key)
  }

  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      width={NAV_WIDTH}
      theme={sidebarTheme}
      style={{
        ...(sidebarTheme === "dark" ? {} : { backgroundColor: "#ffffff" }),
        pointerEvents: props.isBlocked ? 'none' : 'auto'
      }}
      className={`!fixed left-0 top-0 h-screen border-r border-solid ${themeMode === ThemeMode.Dark ? 'border-gray-800' : 'border-[#E6EFF5]'}`}
    >
        {!isSuperAdmin && (
          <>
            <RemainderDaysModal open={isTrial && remainModalOpen} onClose={()=>setRemainModal(false)} />
            <ZeroDayRemainingModal open={isTrial && zeroRemainModalOpen && !extendTrialSubmitted} onClose={()=>setZeroRemainModal(false)}/>
            <RemainingCreditsModal open={remainingModalOpen} onClose={()=>setRemainingModalOpen(false)} />
            <ZeroCreditsModal open={zeroModalOpen} onClose={()=>setZeroModalOpen(false)}/>
            <InsufficientCreditModal open={insufficientModalOpen} onClose={() => {
              setInsufficientModalOpen(false);
              resetAll();
              navigate("/agents/smart-dashboard-agent");
            }} />
            <PaymentDueModal open={!isTrial && paymentDueModalOpen} onClose={() => setPaymentDueModalOpen(false)} notificationData={paymentDueData} />
          </>
        )}
            
      <div className="flex h-full flex-col">
        <NavLogo collapsed={collapsed} onToggle={() => setSettings({ ...settings, themeLayout: collapsed ? ThemeLayout.Vertical : ThemeLayout.Mini })} />
        <Scrollbar>
          <Menu
            mode="inline"
            items={(role_id === "1" ? adminList : menuListCustom).filter(Boolean) as any[]}
            theme={sidebarTheme}
            // selectedKeys={[pathname]}
            // openKeys={openKeys}
            // onOpenChange={setOpenKeys}
            defaultOpenKeys={['/dashboard/dashboard-playgrounds']}
            selectedKeys={[pathname]}
            style={{ background: 'transparent' }}
            className="!border-none custom-menu"
            onClick={onCHange}
          />
        </Scrollbar>
        {/* {
          role_id !== "1" && (
           collapsed?(null):(
             <div className="w-full h-max flex flex-col gap-y-2 p-4">
                <div className="w-full h-max rounded-md border-2 border-border shadow-sm p-2 flex flex-col gap-2">

                  <div className="w-full flex items-center justify-between">
                    <span className=" font-bold text-[14px]">🚀  Your Plan</span>
                    <div className="px-4 rounded-full bg-success-lighter">
                      <span className="text-sm font-semibold text-success-dark">Free Trial</span>
                    </div>
                  </div>

                  <span className="text-sm text-gray-500 font-medium leading-6">Upgrade anytime for more credits and advanced features</span>

                  <div className="flex items-center gap-2">
                      <CheckCircleFilled style={{fontSize:"20px"}}/>
                      <span className="font-bold text-[14px]">30 Credits</span>
                  </div>

                  <Button type="primary" className="mt-2 font-semibold" icon={<StarOutlined/>} style={{backgroundColor:"#784af8"}}>Upgrade Plan</Button>

                </div>

                <div className="w-full h-max rounded-md border-2 border-border shadow-sm p-2 flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <span className="font-bold text-[14px]">Credit Usage</span>
                    <div className="cursor-pointer">
                      <QuestionCircleOutlined/>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 text-sm font-medium">
                    <span>{creditsRemaining}</span>
                    <span>/</span>
                    <span>30</span>
                    <span>Credits</span>
                  </div>

                  <div className="flex flex-col gap-1"> 
                      <Progress percent={((30-creditsRemaining)/30)*100} strokeColor="#784af8" showInfo={false} />
                      <div className="flex items-center self-end gap-1 font-semibold text-sm text-gray-600">
                        <span>{(((30-creditsRemaining)/30)*100).toPrecision(2)}%</span>
                        <span>used</span>
                      </div>
                  </div>

                  <hr  />

                
                <span className="font-bold text-[14px]">Days Remaining</span>

                <div className="flex flex-col">
                  <span className="text-sm font-medium text-gray-700">{daysRemainings} days left in your billing cycle</span>
                  <Progress percent={daysPercent} showInfo={false} strokeColor={"#87d068"}/>
                </div>
                  
                </div>
            </div>
           )
          )
        } */}
        <div className={`mt-auto w-full h-max p-4 mb-4 border-t-[1px] ${themeMode === ThemeMode.Dark ? 'border-gray-800' : 'border-[#F1F5F9]'}`}>
          {
            collapsed ? (
              <div className="flex gap-4 items-center flex-col">
                <div className="bg-[#C41230] size-4  p-4 flex items-center justify-center rounded-full text-white">
                  <span>{userInfo?.name?.[0] || "U"}</span>
                </div>

                <div className=" text-error cursor-pointer" onClick={logout}>
                  <IconButton>
                    <MdLogout size={"25px"} className="text-gray-500" />
                  </IconButton>
                </div>
              </div>
            ) : (
              <div className="flex gap-2 items-center">
                <div className="bg-[#C41230] size-4  p-5 flex items-center justify-center rounded-full">
                  <span className="text-[#fff]">{userInfo?.name?.[0] || "U"}</span>
                </div>
                <div className="flex flex-col">
                  <span className="font-bold truncate text-md w-[150px]">{userInfo?.name || "User"}</span>
                  <span className="text-sm w-[140px] truncate opacity-50 font-medium">{userInfo?.email || ""}</span>
                </div>
                <div className="ml-auto text-error cursor-pointer" onClick={logout}>
                  <IconButton>
                    <MdLogout size={"25px"} className="text-gray-500"/>
                  </IconButton>

                </div>
              </div>
            )
          }
          <div className={`mt-4 flex flex-col items-center justify-center gap-1.5 border-t pt-4 border-dashed ${themeMode === ThemeMode.Dark ? 'border-gray-800' : 'border-gray-200'}`}>
            {!collapsed ? (
              <div className="flex  items-center justify-center w-full gap-1">
                <span className="text-[10px] uppercase tracking-wider font-bold" style={{ color: themeMode === ThemeMode.Dark ? '#94a3b8' : '#CBD5E1' }}>Powered by</span>
                {/* <div className="flex items-center gap-2">
                  <img src={valiantlytixLogo} alt="Valiantlytix Logo" className="w-5 object-contain" />
                  <span className="text-[13px] font-bold tracking-tight" style={{ color: themeMode === ThemeMode.Dark ? '#f1f5f9' : '#0f172a' }}>Valiantlytix</span>
                </div> */}
                <span className="font-bold text-[12px]" style={{ color: themeMode === ThemeMode.Dark ? '#94a3b8' : '#64748B' }}>Valiantlytix</span>
                <span className="text-[10px]  font-medium text-center" style={{ color: themeMode === ThemeMode.Dark ? '#64748b' : '#CBD5E1' }}>
                  © {new Date().getFullYear()}
                </span>
              </div>
            ) : (
              <img src={valiantlytixLogo} alt="Valiantlytix Logo" className="w-6 object-contain mt-1" />
            )}
          </div>
        </div>
      </div>
    </Sider>
  );
}